import { createFileRoute } from "@tanstack/react-router";
import { getIspmHostConfig } from "../config/ispmHostConfig";
import { MfeLoader } from "../mfe/MfeLoader";
import { useHostNavigate } from "../hooks/useHostNavigate";

export const Route = createFileRoute("/dashboard/$")({
  component: IspmMfePage,
});

function IspmMfePage() {
  const onNavigate = useHostNavigate();
  return (
    <MfeLoader
      name="ispm-ui"
      props={{ hostConfig: getIspmHostConfig(onNavigate) }}
    />
  );
}
